import React from 'react';
import Select from 'react-select';

const MultipleSelect = ({
    label,
    options,
    onChange,
    name,
    defaultValue,
    className,
    isMulti = false,
    isClearable = false
}) => {
    const handleChange = (selectedOption) => {
        onChange(name, selectedOption);
    };

    return (
        <div className={`multiple-select-dashboards ${className}`}>
            <label className="select-label-dashboards">{label}</label>
            <Select
                value={defaultValue}
                options={options}
                onChange={handleChange}
                isClearable={isClearable}
                classNamePrefix="select"
                isMulti={isMulti}
            />
        </div>
    );
};

export default MultipleSelect;